import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import A0001Admin from '@/components/functions/A0001Admin/A0001AdminStore'
import D0101Demo from '@/components/functions/D0101Demo/D0101DemoStore'
import M0001User from '@/components/functions/M0001User/M0001UserStore'
import M0002LandingPage from '@/components/functions/M0002LandingPage/M0002LandingPageStore'
import M0003ShoppingCart from '@/components/functions/M0003ShoppingCart/M0003ShoppingCartStore'
import M0004Purchase from '@/components/functions/M0004Purchase/M0004PurchaseStore'
import M0005Frame from '@/components/functions/M0005Frame/M0005FrameStore'
import M0601Survey from '@/components/functions/M0601Survey/M0601SurveyStore'
import OnlineShop from '@/components/functions/M0006OnlineShop/M0006OnlineShopStore'
import Cart from '@/components/functions/M0008ShoppingCart/CartStore'
import CheckOut from '@/components/functions/M0009CheckOut/CheckOutStore'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

Vue.use(Vuex)
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

export default new Vuex.Store({
  modules: {
    Auth,
    A0001Admin,
    D0101Demo,
    M0001User,
    M0002LandingPage,
    M0003ShoppingCart,
    M0004Purchase,
    M0005Frame,
    M0601Survey,
    OnlineShop,
    Cart,
    CheckOut
  }
})
